import Vue from 'vue'
import './auto-height'
import './permission'

Vue.directive('anchor', {
  inserted: function(el, binding) {
    el.onclick = function() {
      // 设置滚动区域id为scrollContent 否则默认body
      let content = document.getElementById('scrollContent') || document.documentElement
      content.scrollTop = document.getElementById('anchor-' + binding.value).offsetTop - content.offsetTop
    }
  }
})
